import { useCallback, useState } from 'react'

export type OpenConsignmentItemState = {
  consignmentItemId: number
  houseConsignmentId: number
  houseConsignmentIndex: number
  consignmentItemIndex: number
}

function useConsignmentItemDrawer() {
  const [openState, setOpenState] = useState<OpenConsignmentItemState | null>(null)

  const openConsignmentItem = useCallback((state: OpenConsignmentItemState) => {
    setOpenState(state)
  }, [])

  const closeDrawer = useCallback(() => {
    setOpenState(null)
  }, [])

  return {
    openState,
    openConsignmentItem,
    closeDrawer,
    isDrawerOpen: openState != null,
  }
}

export default useConsignmentItemDrawer
